export enum DEVICE {
  sm = "(min-width: 480px)",
  md = "(min-width: 768px)",
  lg = "(min-width: 992px)",
  xl = "(min-width: 1200px)",
}
